import { render, staticRenderFns } from "./ProductNavigation.vue?vue&type=template&id=237de2ac&scoped=true&lang=html&"
import script from "./ProductNavigation.vue?vue&type=script&lang=js&"
export * from "./ProductNavigation.vue?vue&type=script&lang=js&"
import style0 from "./ProductNavigation.vue?vue&type=style&index=0&id=237de2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237de2ac",
  null
  
)

export default component.exports